export default __webpack_public_path__ + "static/Gaggenau-08-Regular-38510378bcbf8892bbbc36502a3364c8.woff2";